import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import useCampaignService from "../../services/api/campaignService";
import { campaignValidationSchema } from "../../schemas/campaign";
import { enums } from "../../constants/enum";

import { AddIcon } from "../../assets/icons";
import { Button, PageTitle, Section } from "../../components";
import { DateInput, TextInput } from "../../components/forms";

import "./CampaignsPage.scss";

function AddCampaignPage() {
  const queryClient = useQueryClient();
  const { addCampaign, queryKey } = useCampaignService();
  const navigate = useNavigate();
  const addCampaignMutation = useMutation({
    mutationFn: addCampaign,
  });

  const initialValues = {
    name: "",
    place: "",
    date: "",
    orderNumberSequencePrefix: "",
  };

  function handleAddCampaign(values) {
    addCampaignMutation.mutate(
      { payload: values },
      {
        onSuccess: async (payload) => {
          await queryClient.resetQueries({
            queryKey: [queryKey],
          });
          toast.success(payload?.message);
          navigate("/campaigns", { replace: true });
        },
        onError: (e) => {
          toast.error(
            e.response.data.payload.message || enums.DEFAULT_ERROR_MESSAGE
          );
        },
      }
    );
  }

  return (
    <div className="page add-campaign-page">
      <PageTitle text="Add New Campaign" prev="/campaigns" />

      <Section className="campaign-form">
        <Formik
          initialValues={initialValues}
          validationSchema={campaignValidationSchema}
          onSubmit={handleAddCampaign}
        >
          <Form>
            <TextInput
              name="name"
              label="Campaign name"
              placeholder="Campaign name"
            />
            <TextInput
              name="place"
              label="Campaign location"
              placeholder="Campaign location"
            />
            <div className="input-group">
              <DateInput name="date" label="Date" />
              <TextInput
                name="orderNumberSequencePrefix"
                label="Order number prefix"
                placeholder="Type here"
              />
            </div>
            <Button text="Add New Campaign" type="submit" icon={<AddIcon />} />
          </Form>
        </Formik>
      </Section>
    </div>
  );
}

export default AddCampaignPage;
